import './Services.css';
import { 
  GiGrass, 
  GiBoltCutter, 
  GiGloves, 
  GiRake, 
  GiHighGrass,
  GiTreeBranch 
} from "react-icons/gi";
// Images small
import tonteSmall from '../../assets/images/services/tonte-small.jpg';
import haieSmall from '../../assets/images/services/haie-small.jpg';
import desherbageSmall from '../../assets/images/services/desherbage-small.jpg';
import ramassageSmall from '../../assets/images/services/ramassage-small.jpg';
import debroussaillageSmall from '../../assets/images/services/débroussaillage-small.jpg';
import tronconneuseSmall from '../../assets/images/services/tronconneuse-small.jpg';

// Images medium
import tonteMedium from '../../assets/images/services/tonte-medium.jpg';
import haieMedium from '../../assets/images/services/haie-medium.jpg';
import desherbageMedium from '../../assets/images/services/desherbage-medium.jpg';
import ramassageMedium from '../../assets/images/services/ramassage-medium.jpg';
import debroussaillageMedium from '../../assets/images/services/débroussaillage-medium.jpg';
import tronconneuseMedium from '../../assets/images/services/tronconneuse-medium.jpg';


const Services = () => {
  const servicesList = [
    {
      icon: <GiGrass />,
      title: "Tonte de pelouse",
      description: "Entretien régulier de votre gazon toute l'année avec une attention particulière aux détails.",
      features: ["Tonte hebdomadaire ou bi-mensuelle", "Bordures nettes et précises", "Ramassage des déchets de tonte"],
      images: { small: tonteSmall, medium: tonteMedium },
      eligibleSAP: true
    },
    {
      icon: <GiBoltCutter />,
      title: "Taille de haie",
      description: "Taille et entretien de vos haies et arbustes pour maintenir leur forme et leur santé.",
      features: ["Taille selon les saisons", "Respect de la croissance naturelle", "Évacuation des déchets verts"],
      images: { small: haieSmall, medium: haieMedium },
      eligibleSAP: true
    },
    {
      icon: <GiGloves />,
      title: "Désherbage",
      description: "Désherbage manuel des massifs et allées pour préserver la beauté de vos espaces.",
      features: ["Désherbage écologique", "Protection des plantations", "Traitement préventif"],
      images: { small: desherbageSmall, medium: desherbageMedium },
      eligibleSAP: true
    },
    {
      icon: <GiRake />,
      title: "Ramassage des feuilles",
      description: "Nettoyage saisonnier de votre jardin pour le maintenir propre et accueillant.",
      features: ["Ramassage automnal complet", "Nettoyage des gouttières", "Compostage possible"],
      images: { small: ramassageSmall, medium: ramassageMedium },
      eligibleSAP: true
    },
    {
      icon: <GiHighGrass />,
      title: "Débroussaillage",
      description: "Nettoyage des zones difficiles d'accès et remise en état des terrains abandonnés.",
      features: ["Débroussaillage mécanique", "Évacuation des végétaux", "Remise en état du terrain"],
      images: { small: debroussaillageSmall, medium: debroussaillageMedium },
      eligibleSAP: true
    },
    {
      icon: <GiTreeBranch />,
      title: "Petit élagage",
      description: "Taille et entretien des petits arbres pour leur croissance optimale et votre sécurité.",
      features: ["Taille d'entretien", "Suppression du bois mort", "Respect des périodes de taille"],
      images: { small: tronconneuseSmall, medium: tronconneuseMedium },
      eligibleSAP: true
    },
  ];

  return (
    <section id="services" className="services">
      <div className="service-list">
        {servicesList.map((service, index) => (
          <div key={index} id={`service-${index}`} className="service-item">
            <div className="service-image">
              <img src={service.images.medium} alt={service.title} />
            </div>
            <div className="service-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
              {service.eligibleSAP && (
                <div className="service-sap-info">
                  <span className="sap-text">Éligible crédit d'impôt</span>
                  <span className="sap-percentage">-50%</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;